import React from 'react';
import PropTypes from 'prop-types';
import Tag from './Tag';
import { convertTextToId } from '../../../utils/convertTextToId';
import styles from './Tag.module.scss';
import { Heading } from '../../typography/heading/Heading';

export const TagList = ({ list, title }) => {
  return (
    <>
      <div className={styles.border} />
      <div className={styles.container}>
        {title && (
          <Heading as="h2" align="center" className={styles.title}>
            {title}:
          </Heading>
        )}
        {list && (
          <div className={styles.listBlock}>
            {list.map((item, index) => (
              <Tag
                key={`${convertTextToId(item.title)}_${index}`}
                name={item.title}
                url={item.url}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

TagList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.array.isRequired,
};

TagList.defaultProps = {
  title: '',
  list: [],
};
